import {
  BIconBorderAll,
  BIconPerson,
  BIconBank,
  BIconFileEarmarkSpreadsheet,
} from 'bootstrap-vue'

export default {
  components: {
    BIconBorderAll,
  },
  data() {
    return {
      tabNumber: 0,
      isHidden: false,
      finalTabItems: [],
    }
  },
  computed: {
    route() {
      return this.$route.path
    },
    filtredtabsItem() {
      return [
        {
          title: 'general',
          link: { name: 'document-general', params: {} },
          number: 0,
          icon: BIconPerson,
        },
        {
          title: 'bank',
          link: { name: 'document-bank', params: {} },
          number: 1,
          icon: BIconBank,
        },
        {
          title: 'legal',
          link: { name: 'document-legal', params: {} },
          number: 2,
          icon: BIconFileEarmarkSpreadsheet,
          hidden: !this.$store.state.auth.user.is_legal,
        },
      ].filter(tab => !tab.hidden || tab.hidden !== true)
    },

  },
  watch: {
    route() {
      this.findTab()
    },
  },
  methods: {
    areObjectsEqual(obj1, obj2) {
      // Check if both arguments are objects
      if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        return false
      }

      // Get the keys of both objects
      const keys1 = Object.keys(obj1)
      const keys2 = Object.keys(obj2)

      // Check if the number of keys is different
      if (keys1.length !== keys2.length) {
        return false
      }

      // Check if all keys and values in obj1 exist in obj2
      // eslint-disable-next-line no-restricted-syntax
      for (const key of keys1) {
        if (obj2[key] !== obj1[key]) {
          return false
        }
      }

      return true
    },
    findTab() {
      this.$nextTick(() => {
        const routeParams = JSON.parse(JSON.stringify(this.$route.params))
        delete routeParams.lang
        const tabNumber = this.filtredtabsItem.find(tab => (tab.link.name === this.$route.name
         && this.areObjectsEqual(routeParams, tab.link.params))).number
        if (tabNumber || tabNumber === 0) {
          this.tabNumber = tabNumber
        } else {
          throw new Error('cant find tab number')
        }
      })
    },
    tabClick(tab) {
      this.$router.push(tab.link)
    },
  },
}
